var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    d: "M89.871,48.645c-0.204-0.612-0.777-1.025-1.423-1.025H60.065c-0.646,0-1.219,0.413-1.423,1.025l-1.133,3.397V26.984h3.065 c0.828,0,1.5-0.671,1.5-1.5V17.44c0-0.829-0.672-1.5-1.5-1.5h-4.407v-5.606c0-0.829-0.672-1.5-1.5-1.5h-41.36 c-0.829,0-1.5,0.671-1.5,1.5v5.606h-4.41c-0.829,0-1.5,0.671-1.5,1.5v8.044c0,0.829,0.671,1.5,1.5,1.5h2.82v62.682 c0,0.828,0.671,1.5,1.5,1.5H56.01h36.494c0.828,0,1.5-0.672,1.5-1.5V61.525C94.18,61.047,89.871,48.645,89.871,48.645z  M90.667,60.515c-1.304,0.771-2.779,1.18-4.333,1.18c-1.591,0-3.124-0.478-4.494-1.343V50.62h5.527L90.667,60.515z M69.677,50.62 h9.163v9.733c-1.371,0.864-2.905,1.343-4.496,1.343c-1.66,0-3.259-0.494-4.667-1.434V50.62z M61.146,50.62h5.53v9.638 c-1.414,0.942-3.016,1.437-4.673,1.437c-1.488,0-2.909-0.392-4.181-1.109L61.146,50.62z M14.807,11.834h38.361v4.106H14.807V11.834 z M8.897,18.94h4.41h41.361h4.407v5.044H56.01H11.717h-2.82V18.94z M13.217,26.984H54.51v61.182H13.217V26.984z M57.51,88.166 V63.79c1.409,0.595,2.927,0.905,4.494,0.905c2.191,0,4.304-0.63,6.171-1.83c1.861,1.2,3.973,1.83,6.169,1.83 c2.121,0,4.174-0.588,5.997-1.711c1.821,1.123,3.873,1.711,5.993,1.711c1.616,0,3.209-0.343,4.67-0.987v24.458H57.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    d: "M40.57,34.738H27.409c-0.829,0-1.5,0.671-1.5,1.5v31.877c0,0.828,0.671,1.5,1.5,1.5H40.57c0.829,0,1.5-0.672,1.5-1.5 V36.238C42.07,35.409,41.398,34.738,40.57,34.738z M39.07,66.615H28.909V37.738H39.07V66.615z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.37ea2a47f25b827c34ab0133f5873606.svg";
export { ForwardRef as ReactComponent };